import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  article: {
    padding: '0.5rem 0.75rem',
    display: 'flex',
    gap: '0.5rem',
    flexDirection: 'column',
    backgroundColor: neutral.white,
    borderRadius: '0.75rem',
    border: `1px solid ${neutral[20]}`,
    overflow: 'auto',
    '&[data-is-marketplace="false"] > [aria-label="reasons-for-contact"]': {
      marginBottom: '-0.5rem',
    },
  },
  title: {
    marginBottom: '-0.75rem',
    fontWeight: 600,
    fontSize: '0.625rem',
    lineHeight: '1rem',
    letterSpacing: '0.075rem',
    textTransform: 'uppercase',
    color: neutral[60],
  },

  main: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'space-between',
  },
  userSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& [aria-label="user-tags"]': {
      marginTop: '0.25rem',
      display: 'flex',
      gap: '0.25rem',
      flexWrap: 'wrap',
    },
    '& [aria-label="user-name"]': {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
  },
  actions: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
  },
  action: {
    padding: '0.5rem',
    fontSize: '1.5rem',
    color: neutral[100],
    border: `1px solid ${neutral[30]}`,
    '&:hover': {
      backgroundColor: neutral[30],
    },
    '& [aria-label="icon"]': {
      fill: neutral[100],
    },
  },

  footer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
});
